import { userRequest } from '../requestMethods';
import config from '../config';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN

export const getAlertVehicule = async () => {
  return userRequest.get(`${DOMAIN}/api/event/vehicule_alert`);
};

export const markAlertAsRead = async (id) => {
  return userRequest.put(`${DOMAIN}/api/event/vehicule_alert?id=${id}`);
};

export const getEvent = async (params) => {
  return userRequest.get("https://apidlog.loginsmart-cd.com/api/get_event", {
    params,
  });
};

export const postEvent = async (data) => {
  return userRequest.post(`${DOMAIN}/api/event`, data);
};